import styled, { css } from 'styled-components/macro'
import { resolveResponsiveProp } from 'styles/mixins'
import { Color } from 'styles/types'
import { IconSize } from './types'
import { rotateSequence } from 'styles/animations'

interface WrapperProps {
    size: IconSize | [IconSize, IconSize]
    rotation?: number
    color?: Color
    isSpinning?: boolean
}

export const Wrapper = styled.span<WrapperProps>`
    display: inline-block;
    ${({ size }) =>
        resolveResponsiveProp({
            type: 'font-size',
            value: size,
            unit: 'px',
        })}
    ${({ size }) =>
        resolveResponsiveProp({
            type: 'min-width',
            value: size,
            unit: 'px',
        })}
    ${({ size }) =>
        resolveResponsiveProp({
            type: 'height',
            value: size,
            unit: 'px',
        })}

    
    ${({ color }) =>
        color &&
        css`
            color: ${({ theme }) => theme.colors[color]} !important;
        `}

    ${({ rotation }) =>
        rotation !== undefined &&
        css`
            transition: color 100ms ease-in, transform 200ms ease-in;
            transform: rotate(${rotation}deg);
        `}

    ${({ isSpinning }) =>
        isSpinning &&
        css`
            animation: ${rotateSequence} 1s linear infinite;
        `}
`
